import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import blue from "../../../assets/images/seaweed.jpeg";
import education from "../../../assets/images/education.jpg";
import climate from "../../../assets/images/climate2.jpg";
import marine from "../../../assets/images/mangrove.jpg";
import flagship from "../../../assets/images/flagship.jpg";
import { Paper, Stack } from "@mui/material";

const Details = () => {
  return (
    <Box margin={{ xs: "20% 0%", sm: "3% 0%" }}>
      <Box paddingBottom={{ xs: "10%", sm: "3%" }}>
        <Typography
          variant="h6"
          color="#9DCC49"
          fontWeight={800}
          paddingTop={"4%"}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Box component={"span"}>
            <WaterIcon
              sx={{
                width: 23,
                height: 23,
              }}
            />
          </Box>{" "}
          Our Programs
        </Typography>
        <Typography
          variant="h6"
          color="#317ABE"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          Blue Echo Foundation delivers integrated programs that address
          Nigeria’s most pressing marine and coastal challenges, ecosystem
          degradation, declining fisheries, climate vulnerability, and limited
          livelihood opportunities. Our work combines science, community
          leadership, and partnerships to achieve lasting impact.
        </Typography>
      </Box>
      <Stack spacing={4}>
        <Paper elevation={2} gap={2}>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
            padding={"2%"}
          >
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Box
                component="img"
                height={{ xs: "58vh", sm: "890px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={marine}
                alt={"marine"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Typography
                variant={"h4"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "0% 6% 3% 6%" }}
              >
                Marine and Mangrove Restoration Division
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Goal:{" "}
                </Typography>
                To conserve and restore Nigeria’s marine and mangrove ecosystems
                while strengthening coastal resilience and supporting community
                stewardship.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "2% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Problem:{" "}
                </Typography>
                Nigeria’s mangroves and nearshore ecosystems are under severe
                pressure from deforestation, oil pollution, coastal erosion, and
                weak enforcement of marine protection frameworks.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Our Approach:{" "}
                </Typography>
                We work closely with government agencies, coastal communities,
                and fisherfolk to design and implement locally managed and
                co-managed marine areas and mangrove systems. Our approach
                emphasizes community ownership, science-based restoration, and
                sustainable financing mechanisms such as blue carbon.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                Key Programs
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Mangrove afforestation and blue carbon projects in
                Bayelsa, Delta, and Lagos States
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Community-led Marine Protected Area and LMMA
                co-management
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Shoreline stabilization using nature-based solutions
                such as mangroves and oyster reefs
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Oil spill, plastic pollution, and marine waste
                monitoring initiatives
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Blue carbon credit development to finance long-term
                ecosystem restoration
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                Expected Outcomes
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Restored mangrove and coastal habitats
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Reduced shoreline erosion and flood risk
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Improved fish stocks and ecosystem health
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Strengthened community stewardship and compliance
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Paper elevation={2}>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
            padding={"2%"}
          >
            <Box
              width={{ xs: "100%", sm: "50%" }}
              display={{ xs: "block", sm: "none" }}
            >
              <Box
                component="img"
                height={{ xs: "58vh", sm: "800px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={blue}
                alt={"Blue_economy"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Typography
                variant={"h4"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "0% 6% 3% 0%" }}
              >
                Blue Economy and Livelihood Development
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Goal:{" "}
                </Typography>
                To build inclusive, climate-smart coastal economies that improve
                incomes while reducing pressure on marine ecosystems.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "2% 6% 2% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Problem:{" "}
                </Typography>
                Overfishing, post-harvest losses, limited access to finance, and
                weak market linkages constrain coastal livelihoods, particularly
                for women and youth.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "2% 6% 2% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Our Approach:{" "}
                </Typography>
                We support sustainable aquaculture and marine enterprises that
                are environmentally responsible, economically viable, and
                socially inclusive. Programs are co-designed with communities
                and linked to markets, finance, and skills development.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                Key Programs
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Seaweed, oyster, shrimp, and crab farming along
                Nigeria’s coastal belts
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; GIFT tilapia cage culture systems and cold chain
                development
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Women and Youth Coastal Enterprise Scheme, providing
                access to finance, inputs, and technical training
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Eco-tourism and blue cultural heritage initiatives
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Partnerships with off-takers and exporters for regional
                and international blue food markets
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                Expected Outcomes
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Increased household incomes
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Reduced post-harvest losses
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Sustainable employment for women and youth
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 1% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Lower fishing pressure on wild stocks
              </Typography>
            </Box>
            <Box width={"50%"} display={{ xs: "none", sm: "block" }}>
              <Box
                component="img"
                height={{ xs: "28vh", sm: "800px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={blue}
                alt={"Blue_economy"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
          </Box>
        </Paper>
        <Paper elevation={2}>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
            padding={"2%"}
          >
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Box
                component="img"
                height={{ xs: "58vh", sm: "700px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={climate}
                alt={"climate_resilience"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Typography
                variant={"h4"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "0% 6% 3% 6%" }}
              >
                Climate and Coastal Resilience
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Goal:{" "}
                </Typography>
                To strengthen the adaptive capacity of coastal ecosystems and
                communities in the face of climate change.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "2% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Problem:{" "}
                </Typography>
                Sea-level rise, coastal erosion, flooding, and extreme weather
                events pose growing risks to coastal settlements,
                infrastructure, and livelihoods.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Our Approach:{" "}
                </Typography>
                We combine applied research, nature-based solutions, and policy
                advocacy to integrate climate resilience into coastal planning
                and development.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                Key Programs
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Coastal erosion and flood risk research
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Blue carbon ecosystem assessments and resilience
                mapping
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Disaster risk reduction and early warning systems for
                coastal communities
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Advocacy for climate adaptation policies in coastal and
                marine planning
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Integration of renewable energy solutions such as solar
                and tidal power in blue communities
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                Expected Outcomes
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Reduced climate vulnerability
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Improved coastal planning and preparedness
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                &#10033; Increased resilience of ecosystems and livelihoods
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Paper elevation={2}>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
            padding={"2%"}
          >
            <Box
              width={{ xs: "100%", sm: "50%" }}
              display={{ xs: "block", sm: "none" }}
            >
              <Box
                component="img"
                height={{ xs: "58vh", sm: "650px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={education}
                alt={"educational"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Typography
                variant={"h4"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "0% 6% 3% 0%" }}
              >
                Education, Research and Innovation
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Goal:{" "}
                </Typography>
                To advance marine science, ocean literacy, and technology-driven
                conservation in Nigeria.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "2% 6% 2% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Problem:{" "}
                </Typography>
                Limited data, weak ocean literacy, and low access to technology
                constrain effective marine governance and community engagement.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "1% 0%", sm: "0% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                <Typography
                  component={"span"}
                  fontWeight={700}
                  color={"#317ABE"}
                >
                  Our Approach:{" "}
                </Typography>
                We invest in research, education, and innovation to build
                knowledge, skills, and evidence for decision-making.
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                Key Programs
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Blue Echo Marine Research Labs focusing on
                biodiversity, pollution, and fisheries stock assessment
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Coastal schools ocean literacy program,{" "}
                <i>Adopt a Shoreline</i>
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Use of drones, GIS, and AI tools for coastal monitoring
                and data collection
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Knowledge exchange with global partners including
                WorldFish, NOAA, and leading universities
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "2% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                Expected Outcomes
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Improved marine data and research capacity
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Increased public awareness and youth engagement
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 0%" }}
                lineHeight={1.5}
              >
                &#10033; Stronger evidence base for policy and investment
              </Typography>
            </Box>
            <Box width={"50%"} display={{ xs: "none", sm: "block" }}>
              <Box
                component="img"
                height={{ xs: "28vh", sm: "650px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={education}
                alt={"educational"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
          </Box>
        </Paper>
        <Paper elevation={2}>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
            padding={"2%"}
          >
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Box
                component="img"
                height={{ xs: "58vh", sm: "350px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={flagship}
                alt={"flagship"}
                sx={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  "&:hover": {
                    opacity: 0.5,
                  },
                }}
              />
            </Box>
            <Box width={{ xs: "100%", sm: "50%" }}>
              <Typography
                variant={"h4"}
                fontWeight={700}
                textAlign={"left"}
                color={"#317ABE"}
                padding={{ xs: "2% 0%", sm: "0% 6% 3% 6%" }}
              >
                Flagship Programs, 2025–2030
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                <strong>&#8258; The Mangrove One Million Project </strong>{" "}
                Restoring one million mangrove seedlings along Nigeria’s
                coastline by 2030
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                <strong>&#8258; Women of the Blue Coast Initiative </strong>{" "}
                Empowering 10,000 women through coastal aquaculture and marine
                enterprises
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                <strong>&#8258; Blue Carbon for Nigeria </strong> Developing
                national blue carbon pathways for climate finance and
                restoration
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                <strong>&#8258; Blue Schools Program </strong> Integrating
                marine and coastal education into secondary school curricula
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={400}
                textAlign={"left"}
                color={"#4f4f4f"}
                padding={{ xs: "2% 0%", sm: "1% 6% 0% 6%" }}
                lineHeight={1.5}
              >
                <strong>&#8258; Coastal Data Hub </strong> Real-time satellite
                and community-based monitoring of Nigeria’s coastal health
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Stack>
    </Box>
  );
};

export default Details;
